import React from "react";

import Container from "../Container";
import RichtextRenderer from "../RichtextRenderer";
import Button from "../basic/Button";

const AboutSection = ({ aboutTitle, aboutSubitle, aboutText, aboutButtonLabel, aboutButtonLink }) => {
  return (
    <Container additionalPx>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-48px">
        <div>
          <div className="flex items-center gap-36px">
            <h2 className="text-gold !mb-0 whitespace-nowrap">{aboutTitle}</h2>
            <div className="w-full max-w-380px h-2px bg-gold-transparent" />
          </div>
          <div className="leading-normal font-[Montserrat] font-medium text-40px md:text-60px text-nav-green">
            {aboutSubitle}
          </div>
        </div>
        <div>
          <RichtextRenderer data={aboutText} />
          <Button
            variant="beige"
            className="flex items-center rounded-none !w-fit !py-0"
            buttonClassName="!py-0"
            px="px-27px"
            link={aboutButtonLink}
            arrow
            arrowRotated={false}
          >
            {aboutButtonLabel}
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default AboutSection;
